webpackJsonp([8],{

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_expo__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_expo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_expo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            expo: __WEBPACK_IMPORTED_MODULE_0__data_expo___default.a
        };
    },

    methods: {
        tweet: function tweet() {
            var width = 575;
            var height = 400;
            var left = (window.screen.width - width) / 2;
            var top = (window.screen.height - height) / 2;
            var url = 'https://twitter.com/share?url=' + encodeURIComponent(document.location.protocol + '//' + document.location.host) + '&text=My website made with Buefy!&hashtags=madewithbuefy';
            var opts = 'status=1,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;

            window.open(url, '', opts);
        },
        getImg: function getImg(img) {
            return __webpack_require__(925)("./" + img);
        }
    }
});

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content expo"
  }, [_c('div', {
    staticClass: "expo-head"
  }, [_c('div', {
    staticClass: "expo-head-text"
  }, [_vm._v("Show us your own project or job!")]), _vm._v(" "), _c('div', {
    staticClass: "expo-head-button"
  }, [_c('button', {
    staticClass: "button is-twitter",
    on: {
      "click": _vm.tweet
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "twitter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("#MadeWithBuefy")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.expo), function(item, i) {
    return _c('div', {
      key: item.title,
      staticClass: "column has-text-centered",
      class: i % 3 ? 'is-half' : 'is-full',
      staticStyle: {
        "padding-right": "2.5em"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "image-has-shadow",
      attrs: {
        "src": _vm.getImg(item.img),
        "alt": item.title
      }
    })]), _vm._v(" "), _c('p', [_c('a', {
      staticClass: "title is-5",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "subtitle is-6"
    }, [_vm._v("\n                        " + _vm._s(new Date(item.date).toLocaleDateString()) + "\n                    ")])])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1300),
  /* template */
  __webpack_require__(1301),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports = [{"title":"Sponsus","date":"2019-11-29","img":"sponsus.png","url":"https://sponsus.org/"},{"title":"Dogs Welcome","date":"2019-11-05","img":"dogswelcome.png","url":"https://dogswelcome.in/"},{"title":"Rate My Meeting","date":"2019-11-05","img":"ratemymeeting.png","url":"https://ratemymeeting.co/"},{"title":"Rekord Cloud","date":"2019-11-05","img":"rekordcloud.png","url":"https://rekord.cloud/"},{"title":"Yan Dev","date":"2019-10-25","img":"yandev.png","url":"https://yandev.de/"},{"title":"EL Catre","date":"2019-10-22","img":"elcatre.jpg","url":"https://elcatre.com/"},{"title":"Frenl","date":"2019-10-20","img":"frenl.png","url":"https://www.frenl.com"},{"title":"Kulap","date":"2019-09-04","img":"kulap.png","url":"https://www.kulap.io","featured":true},{"title":"Gravium Wallet","date":"2019-09-03","img":"gravium.png","url":"https://gravium.io/wallet-2-0"},{"title":"JustBoil.me","date":"2019-08-20","img":"justboilme.png","url":"https://justboil.me"},{"title":"Course Cosmos","date":"2019-08-11","img":"coursecosmos.png","url":"https://coursecosmos.com"},{"title":"FileGator","date":"2019-06-18","img":"filegator.png","url":"https://filegator.io"},{"title":"Traject Ubudu","date":"2019-06-18","img":"traject-ubudu.png","url":"https://traject.ubudu.com"},{"title":"Travelstop","date":"2019-06-13","img":"travelstop.png","url":"https://travelstop.com","featured":true},{"title":"Git Stars","date":"2019-06-01","img":"git-stars.png","url":"https://git-stars.netlify.com"},{"title":"Marvel Match","date":"2019-05-24","img":"marvelmatch.png","url":"https://marvelmatch.com"},{"title":"FOE Tools","date":"2019-05-24","img":"foe-tools.png","url":"https://foe-tools.github.io"},{"title":"Brand Finance","date":"2019-05-24","img":"brandirectory.png","url":"https://brandirectory.com"},{"title":"Repo Remover","date":"2019-05-24","img":"reporemover.png","url":"https://reporemover.xyz"},{"title":"Nest&Cut","date":"2019-05-22","img":"nestandcut.png","url":"https://nestandcut.com"},{"title":"Okuna","date":"2019-04-24","img":"openbook.png","url":"https://www.okuna.io","featured":true},{"title":"Immunization Academy","date":"2019-04-24","img":"immunization-academy.png","url":"https://www.immunizationacademy.com"},{"title":"Switchblade","date":"2019-04-24","img":"switchblade.png","url":"https://switchblade.xyz"},{"title":"Moonlight","date":"2019-04-24","img":"moonlight.png","url":"https://www.moonlightwork.com","featured":true},{"title":"Im Done","date":"2019-04-24","img":"imdone.png","url":"https://imdone.io"},{"title":"Tainacan","date":"2019-04-24","img":"tainacan.png","url":"http://tainacan.org/"},{"title":"Counter Network","date":"2019-04-24","img":"counter-network.png","url":"https://counter.network"},{"title":"Gods Unchained","date":"2019-04-24","img":"godsunchained.png","url":"https://godsunchained.info"},{"title":"Picano","date":"2019-04-24","img":"picano.png","url":"https://picano.co"},{"title":"Reaction Role","date":"2019-04-24","img":"reaction-role.png","url":"https://reaction-role.com"},{"title":"Buchfink","date":"2019-04-24","img":"buchfink.png","url":"https://buchfink.ch"},{"title":"Salamander Garten","date":"2019-04-24","img":"salamander-garten.png","url":"https://voranalyse.salamander-garten.ch"},{"title":"Pumpipumpe Map","date":"2019-04-24","img":"pumpipumpe-map.png","url":"https://map.pumpipumpe.ch"}]

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./brandirectory.png": 926,
	"./buchfink.png": 927,
	"./counter-network.png": 928,
	"./coursecosmos.png": 929,
	"./dogswelcome.png": 930,
	"./elcatre.jpg": 931,
	"./filegator.png": 932,
	"./foe-tools.png": 933,
	"./frenl.png": 934,
	"./git-stars.png": 935,
	"./godsunchained.png": 936,
	"./gravium.png": 937,
	"./imdone.png": 938,
	"./immunization-academy.png": 939,
	"./justboilme.png": 940,
	"./kulap.png": 941,
	"./marvelmatch.png": 942,
	"./moonlight.png": 943,
	"./nestandcut.png": 944,
	"./openbook.png": 945,
	"./picano.png": 946,
	"./pumpipumpe-map.png": 947,
	"./ratemymeeting.png": 948,
	"./reaction-role.png": 949,
	"./rekordcloud.png": 950,
	"./reporemover.png": 951,
	"./salamander-garten.png": 952,
	"./sponsus.png": 953,
	"./switchblade.png": 954,
	"./tainacan.png": 955,
	"./traject-ubudu.png": 956,
	"./travelstop.png": 957,
	"./yandev.png": 958
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brandirectory.d48a052.png";

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/buchfink.dabdb37.png";

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/counter-network.67e5a51.png";

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coursecosmos.bbfa297.png";

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dogswelcome.e2ff986.png";

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/elcatre.a39506f.jpg";

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/filegator.ac65a2e.png";

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/foe-tools.295a881.png";

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/frenl.5e90d04.png";

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/git-stars.9149dd4.png";

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/godsunchained.a85cc28.png";

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gravium.532dfcb.png";

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/imdone.8db3885.png";

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/immunization-academy.6095c98.png";

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/justboilme.81faca5.png";

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kulap.06ce091.png";

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/marvelmatch.cc34f75.png";

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/moonlight.52440e8.png";

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nestandcut.1ff4f8a.png";

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/openbook.eb2bf8b.png";

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/picano.9ee55c3.png";

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pumpipumpe-map.b207af4.png";

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ratemymeeting.345bb37.png";

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/reaction-role.bb2e85e.png";

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rekordcloud.4c72ae4.png";

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/reporemover.783c4e4.png";

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/salamander-garten.e1b1af4.png";

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sponsus.b212fc7.png";

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/switchblade.794330f.png";

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tainacan.5a127c4.png";

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traject-ubudu.826bfa4.png";

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/travelstop.7e086d2.png";

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yandev.cfc3d8d.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.9430dce9fd541bebe0ed.js